import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "assets/scss/material-kit-react.scss?v=1.9.0";

// pages for this product
import Main from "./views/Main/index";
import SignUp from "./views/Main/index";
import SignIn from "./views/SignIn/index";
import SendCode from "./views/SendCode/index";
import VerifyCode from "./views/VerifyCode/index";
import Profile from "./views/Profile/index";
import Expositions from "./views/Expositions/Main/index";
import TopDevMainPage from "./views/TopDev/Main/index";
import TopDevEnterPage from "./views/TopDev/Enter/index";
import RoboCupSoccerSimulationMainPage from "./views/RoboCupSoccerSimulation/Main/index";
import UstmbJamMainPage from "./views/UstmbJam/Main/index";
import ACCNMainPage from "./views/ACCN/Main/index";
import ITnextMainPage from "./views/ITNext/Main/index";

import MpmMainPage from "./views/Mpm/Main/index";
import MPMEvent from "./views/Mpm/Event/index";
import MPMJudge from "./views/Mpm/Judge/index";
import ITWeekendMainPage from "./views/ITWeekend/Main/index";
import SpaghettiMainPage from "./views/Spaghetti/Main/index";
import SpaghettiLeaderBoardPage from "./views/Spaghetti/LeaderBoard/index";
import SpaghettiAdminPage from "./views/Spaghetti/Admin/index";
import PenetrationTesting from "./views/PenetrationTesting/Main/index";
import Tour from "./views/Tour/Main/index";
import ICTChallengesMainPage from "./views/ICTChallenges/Main/index";
import ICTChallengesEvent from "./views/ICTChallenges/Event/index";

import ContactUsMainPage from "./views/ContactUs/Main/index";
import AboutUsMainPage from "./views/AboutUs/Main/index";
import LearningMainPage from "./views/Learning/Main/index";

import ExpositionsVerify from "./views/Expositions/Verify/index";
import LandingRightel from "./views/Landing/rightel.js";
import LearningVerify from "./views/Learning/Verify/index";
import LearningLog from "./views/Learning/Log/index";
import AdminMainPage from "./views/Admin/Main/index";
import ShowResume from "./views/ShowResume/Main/index";
import LearningDetails from "./views/Learning/Details/index";
import LearningCertificate from "./views/Learning/Certificate/index";

import UstmbChallenge from "./views/UstmbJam/Challenge/index";
import ACCNChallenge from "./views/ACCN/Challenge/index";
import TopDevChallenge from "./views/TopDev/Challenge/index";
import NotFound from "./views/NotFound/index";
import CompleteRegistration from "./views/CompleteRegistration/index";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { StylesProvider, jssPreset } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";


var hist = createBrowserHistory();

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createMuiTheme({
  direction: "rtl",
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  }
});

const rootElement = document.getElementById("root");

var APP = <StylesProvider jss={jss}>
  <MuiThemeProvider theme={theme}>
    <Router history={hist}>
      <Switch>
        <Route path="/u/r/:id" component={ShowResume} />
        <Route path="/Courses/ZarinPal/Verify/" component={LearningVerify} />
        <Route path="/Expositions/ZarinPal/Verify/" component={ExpositionsVerify} />
        <Route path="/Expositions/Main/" onEnter={reload} />
        <Route path="/Complete" component={CompleteRegistration} />
        <Route path="/SignIn" component={SignIn} />
        <Route path="/SignUp" component={SignUp} />
        <Route path="/SendCode" component={SendCode} />
        <Route path="/Profile/Page/:Page" component={Profile} />
        <Route path="/Profile" component={Profile} />
        <Route path="/Expositions" component={Expositions} />
        <Route path="/TopDev/Challenges/:ChallengeId" component={TopDevChallenge} />
        <Route path="/UstmbTopDev/Challenges/:ChallengeId" component={UstmbChallenge} />
        <Route path="/ACCN/Challenges/:ChallengeId" component={ACCNChallenge} />
        <Route path="/VerifyCode/:PhoneNumber" component={VerifyCode} />
        <Route path="/UstmbTopDev" component={UstmbJamMainPage} />
        <Route path="/ACCN" component={ACCNMainPage} />
        <Route path="/TopDev/Enter" component={TopDevEnterPage} />
        <Route path="/TopDev" component={TopDevMainPage} />
        <Route path="/MPM/Event/" component={MPMEvent} />.
        <Route path="/MPM/Judge/" component={MPMJudge} />.
        <Route path="/MPM" component={MpmMainPage} />
        <Route path="/ITWeekend" component={ITWeekendMainPage} />
        <Route path="/ITNext" component={ITnextMainPage} />
        <Route path="/ICTChallenge/Event/" component={ICTChallengesEvent} />.
        <Route path="/ICTChallenge" component={ICTChallengesMainPage} />
        <Route path="/SOPC/LeaderBoard" component={SpaghettiLeaderBoardPage} />
        <Route path="/SOPC/Admin" component={SpaghettiAdminPage} />
        <Route path="/SOPC" component={SpaghettiMainPage} />
        <Route path="/RoboCupSoccerSimulation" component={RoboCupSoccerSimulationMainPage} />
        <Route path="/ContactUs" component={ContactUsMainPage} />
        <Route path="/AboutUs" component={AboutUsMainPage} />
        <Route path="/Landing/Rightel" component={LandingRightel} />
        <Route path="/Courses/Logs" component={LearningLog} />
        <Route path="/Courses/Details/:id/:name?" component={LearningDetails} />
        <Route path="/Courses/Certificate/:id" component={LearningCertificate} />
        <Route path="/Courses/Section/:id/:subId" component={LearningMainPage} />
        <Route path="/Courses/Section/:id" component={LearningMainPage} />
        <Route path="/Courses" component={LearningMainPage} />
        <Route path="/Services/PenetrationTesting" component={PenetrationTesting} />
        <Route path="/Services/Tour" component={Tour} />
        <Route path="/Admin/Section/:id" component={AdminMainPage} />
        <Route path="/Admin" component={AdminMainPage} />
        <Route exact path="/" component={Main} />
        <Route component={NotFound} />

      </Switch>
    </Router>
  </MuiThemeProvider >
</StylesProvider>

ReactDOM.hydrate(APP, rootElement);


const reload = () => window.location.reload();

